import React from "react";
import { Route, Redirect } from "react-router-dom";
// import { getTheUserFromStorage } from "./../services/auth";

const ProtectedRoute = ({
  isLogged,
  path,
  component: Component,
  render,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        // let user = getTheUserFromStorage();
        if (!isLogged)
          return (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: props.location },
              }}
            />
          );
        return Component ? <Component {...props} /> : render(props);
      }}
    />
  );
};

export default ProtectedRoute;
